import React from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from '../../i18n';

const StrengthActions = ({ onSave, onDelete, onHide, isSubmitting }) => {
  const { t } = useTranslation();

  const handleCopy = () => alert(t('activityDetails.copyNotImplemented'));
  const handleMove = () => {
    const newDate = prompt(t('activityDetails.movePrompt'));
    if (newDate) alert(t('activityDetails.movedTo', { date: newDate }));
  };

  return (
    <>
      <Button variant="danger" onClick={onDelete}>{t('common.delete')}</Button>
      <Button variant="secondary" onClick={handleCopy}>{t('calendar.copy')}</Button>
      <Button variant="warning" onClick={handleMove}>{t('cycleTemplatesPanel.move')}</Button>
      <Button variant="primary" onClick={onSave} disabled={isSubmitting}>
        {isSubmitting ? t('activityDetails.saving') : t('common.save')}
      </Button>
      <Button variant="secondary" onClick={onHide}>{t('activityDetails.close')}</Button>
    </>
  );
};

export default StrengthActions;
